import axios from 'axios';
import ExEnv from 'exenv';
import { UserActionCreators } from '../actions/user';
import { toastr } from 'react-redux-toastr';

export default {
	setup: (store, history) => {
		axios.interceptors.request.use((request) => {
			if (ExEnv.canUseDOM && window.sessionStorage.getItem('_at')) {
				request.headers['Authorization'] = `Bearer ${window.sessionStorage.getItem('_at') || ''}`;
			}

			return request;
		}, (error) => error);

		axios.interceptors.response.use(
			(response) => {
				if (response.config.method === "get") {
					return new Promise(resolve => setTimeout(() => resolve(response), 1000))
				}
				return response;
			},
			(error) => {
				let unauthorizeRequest = error.config;
				if ([ 401, 403 ].includes(error.response.status) && !unauthorizeRequest.__retry) {
					unauthorizeRequest.__retry = true;
					return axios
						.post('api/auth/refresh-token', {
							token: `${ExEnv.canUseDOM ? window.sessionStorage.getItem('_at') || '' : ''}`,
							refreshToken: `${ExEnv.canUseDOM ? window.localStorage.getItem('_rt') || '' : ''}`
						})
						.then((refreshResponse) => {
							if (ExEnv.canUseDOM) {
								if (refreshResponse.data.token) {
									window.sessionStorage.setItem('_at', refreshResponse.data.token);
								}
								if (refreshResponse.data.refreshToken) {
									window.localStorage.setItem('_rt', refreshResponse.data.refreshToken);
								}
							}
							unauthorizeRequest.headers['Authorization'] = `Bearer ${refreshResponse.data.accessToken}`;
							return axios(unauthorizeRequest);
						})
						.catch((refreshError) => {
							store.dispatch(UserActionCreators.logoutUser());
							if (error.response.status === 401) {
								store.dispatch(toastr.info('Twoja sesja wygasła'));
							}
							if (error.response.status === 403) {
								store.dispatch(toastr.info('Twoja uprawnienia wygasły'));
							}
						});
				}
				throw error;
			}
		);
	}
};
